module.exports = __webpack_public_path__ + "static/media/icon_ceramic_metal_7.b5f6e8e0.svg";